import React from 'react';
import styled from 'styled-components';
import LazyLoad from 'react-lazyload';
import styles from '@utils/styles';
import breakpoints from '@repo/ui-components/breakpoints';
import PageWrapper from '@repo/ui-components/page-wrapper/PageWrapper';
import { Articles } from '@components/articles';

const Heading = styled.h2<{ alignText?: string }>`
  font-weight: ${styles.fontWeight.medium};
  text-align: ${({ alignText }) => alignText};
`;

const InnerContainer = styled.div`
  max-width: ${breakpoints.xl};
  margin: 0 auto;
`;

const ArticlesContainer = styled.div`
  p {
    margin: 0 0 1rem 0;
    padding: 0;
  }
  a {
    font-weight: ${styles.fontWeight.medium};
    margin: 0;
  }
  h2 {
    margin: 0;
    min-height: 65px;
    margin-top: 1rem;

    a {
      font-size: ${styles.fontSize['1xl']};
      color: ${styles.colors.gray[500]};

      &:hover {
        color: ${styles.colors.orange[500]};
      }
    }
  }
`;

interface FeatureColumnsProps {
  items: {
    title?: string;
    button_link?: string;
    text?: string;
    button_label?: string;
    enable_image?: boolean;
    image?: string;
  }[];
  settings: {
    title?: string;
    align_text?: string;
  };
  CDN_URL: string;
}

const FeatureColumns = ({ items, settings, CDN_URL }: FeatureColumnsProps) => (
  <PageWrapper
    fullWidth
    background={styles.colors.gray[100]}
    padding="1rem 1.625rem"
  >
    <LazyLoad height="100%">
      <InnerContainer>
        {settings?.title && (
          <Heading alignText={settings?.align_text}>{settings?.title}</Heading>
        )}
        <ArticlesContainer>
          <Articles
            className="homepage-articles"
            articles={items.map(item => ({
              title: item.title,
              handle: item.button_link
                .replace('shopify://collections/', '')
                .replace('shopify://products/', '/')
                .replace('shopify://pages/', '/')
                .replace('shopify://blogs/news/', '')
                .replace('shopify://policies', '/'),
              excerpt: item.text,
              readMore: item?.button_label,
              image: item?.enable_image
                ? {
                    altText: item.title,
                    src: item.image.replace('shopify://shop_images/', CDN_URL),
                  }
                : null,
            }))}
          />
        </ArticlesContainer>
      </InnerContainer>
    </LazyLoad>
  </PageWrapper>
);

export default FeatureColumns;
